import React, { forwardRef } from "react";
import "./FormControl.scss";
import {  FormControlProps } from "./FormControl.types";

/**
 * Primary UI component for user interaction
 */

const FormControl = ({
    onBlur = () => false,
    onFocus = () => false,
    label,
    children,
    error,
    errorMessages,
    errorMessage,
    errorStyle
}: FormControlProps, ref) => {
  return (
    <div      
     onFocus={(e) => { onFocus(e); }}
     onBlur={(e) => { onBlur(e); }}
     ref={ref}
    >
        <label> {label} </label>
        {children}
        {/* 
          If error true and errorMessage passed, return the single error message.
        */}
        {error && errorMessage ? <div className={`alteon-entryfield-formlabel ${errorStyle}`}>{errorMessage}</div> : null}
        {/* 
          If error true and error messages map over input array of objects and display passed in Error.
        */}
        {error && errorMessages ? errorMessages.map(err => {
          return(
            <div key={err.error} className="alteon-entryfield-formlabel"> {err.error}</div>
          )
        }) : null}
    </div>
  )
};

export default forwardRef(FormControl);